export default __webpack_public_path__ + "static/media/02-large.6ef51d5f.jpg";